import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import commonNetwork from "../../common/api/commonNetwork";

export const getFirmWhatsappInfo = createAsyncThunk(
    "/firmWhatsappInfo/getFirmWhatsappInfo",
    async (_, { rejectWithValue }) => {
        try {
            // authToken eklenecek cookie,local vs biryerden okunup
            const { data, errorMessage, isSuccess } = await commonNetwork.get("/FirmWhatsappInfo/getFirmWhatsappInfo");
            if (isSuccess) {
                return data;
            } else {
                return rejectWithValue(data);
            }
        } catch (e: any) {
            return rejectWithValue(e.data.message);
        }
    }
);

export const firmWhatsappInfoSlice = createSlice({
  name: "firmWhatsappInfo",
  initialState: {
    firmWhatsappInfo: [],
    isFetching: false,
    isSuccess: false,
    isError: false,
    errorMessage: "",
  },
  reducers: {
    clearState: (state) => {
      state.firmWhatsappInfo = [];
      state.isFetching = false;
      state.isSuccess = false;
      state.isError = false;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getFirmWhatsappInfo.fulfilled, (state, { payload }) => {
      state.firmWhatsappInfo = payload ?? [];;
      state.isFetching = false;
      state.isSuccess = true;
      state.isError = false;
      return state;
    });
    builder.addCase(getFirmWhatsappInfo.rejected, (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      // state.errorMessage = payload.message;
    });
    builder.addCase(getFirmWhatsappInfo.pending, (state) => {
      state.isFetching = true;
    });
  },
});
export const { clearState } = firmWhatsappInfoSlice.actions;

export const firmWhatsappInfoSelector = (state:any) => state.firmWhatsappInfo;

export const firmWhatsappInfoReducer = firmWhatsappInfoSlice.reducer;